const doc = [({"en":({"js":({"routes":({"admin":({"users":({"index":({"add_new_user":"Add new user"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;